import { useEffect, useRef } from 'react';
import type { LogEntry } from '../lib/elm327.ts';

// Every byte in and out of the adapter. When a scan misbehaves on real
// hardware this is the only view that tells you whether the adapter answered
// wrongly or the parser read it wrongly.

export function Terminal({ log }: { log: LogEntry[] }) {
  const ref = useRef<HTMLDivElement>(null);
  const pinnedToBottom = useRef(true);

  useEffect(() => {
    const el = ref.current;
    if (el && pinnedToBottom.current) el.scrollTop = el.scrollHeight;
  }, [log]);

  if (log.length === 0) {
    return (
      <div className="empty">
        <strong>Nothing on the wire yet</strong>
        Run a scan and every command and reply appears here.
      </div>
    );
  }

  const start = log[0].at;

  return (
    <div
      className="terminal"
      ref={ref}
      onScroll={(e) => {
        const el = e.currentTarget;
        // Re-pin only when the user scrolls back to the bottom themselves.
        pinnedToBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 24;
      }}
    >
      {log.map((entry, i) => (
        <div key={i}>
          <span className="t">{String(((entry.at - start) / 1000).toFixed(2)).padStart(6)} </span>
          <span className={entry.direction}>
            {arrow(entry.direction)} {entry.text}
          </span>
        </div>
      ))}
    </div>
  );
}

function arrow(direction: LogEntry['direction']): string {
  return { tx: '>>', rx: '<<', info: '••', error: '!!' }[direction];
}
